import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';

import PDPShownIn from 'components/consumer/PDP/PDPShownIn';
import 'react-photoswipe/lib/photoswipe.css';

const PhotoSwipe = loadable(() => import('react-photoswipe'));

const PDPPinchToZoomGallery = ({
  isOpen = false,
  isEditOrder = false,
  photos = [],
  selectedPhotoIndex,
  setSelectedPhotoIndex,
  onClose,
}) => (
  <div className="PDPPinchToZoomGallery">
    <PhotoSwipe
      className="PDPPinchToZoomGallery__PhotoSwipe z-[1] [&_img]:object-contain"
      isOpen={isOpen}
      items={photos.map(({ src }) => ({
        src,
        w: 3000,
        h: 1500,
      }))}
      options={{
        index: selectedPhotoIndex,
        history: false,
      }}
      onClose={onClose}
      afterChange={updatedData => {
        if (updatedData && updatedData.currItem) {
          const updatedSelectedIndex = photos.findIndex(
            photo => photo.src === updatedData.currItem.src
          );

          setSelectedPhotoIndex(updatedSelectedIndex);
        }
      }}
    />

    <div
      className={classNames('z-[2000] fixed bottom-0 left-0 right-0 p-4 ', {
        hidden: !isOpen,
        flex: isOpen,
      })}
    >
      <PDPShownIn
        fullWidth
        isEditOrder={isEditOrder}
        optionId={photos?.[selectedPhotoIndex]?.optionId}
        valueId={photos?.[selectedPhotoIndex]?.valueId}
        upholsteryName={photos?.[selectedPhotoIndex]?.upholsteryName}
        onSelection={() => onClose(true)}
      />
    </div>
  </div>
);

PDPPinchToZoomGallery.propTypes = {
  isOpen: PropTypes.bool,
  isEditOrder: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  photos: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      id: PropTypes.string,
      type: PropTypes.string,
    })
  ),
  selectedPhotoIndex: PropTypes.number,
  setSelectedPhotoIndex: PropTypes.func,
};

export default PDPPinchToZoomGallery;
